import {
  SET_SELECTED_DATE,
  SET_TIMING_SELECTED,
  SET_EMPLOYEE_SELECTED_ID,
  SET_APPOINTMENT_EMPLOYEE_DETAILS,
  SET_MODAL_ID,
  SET_EMPLOYEES_AND_SERVICE,
  SET_FROM,
  SET_CUSTOMER_DETAILS,
  SAVE_FORM_DATA,
  SET_CONTINUE_BOOKING_DATA,
  RESET_CONTINUE_BOOKING_DATA,
} from "../constants/ActionTypes";

const initialState = {
  dateSelected: "",
  timingSelected: "",
  employeeIdSelected: "",
  employeeFullName: "",
  employeeShortName: "",
  appointmentEmployeeDetails: {},
  displayId: 1,
  employeeSelected: [],
  serviceSelected: "",
  from: "",
  customerDetails: {},
  dataOfForm: {},
  continueBooking: false,
  appointmentData: ""
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_SELECTED_DATE:
      return { ...state, dateSelected: payload };

    case SET_TIMING_SELECTED:
      return { ...state, timingSelected: payload };

    case SET_EMPLOYEE_SELECTED_ID:
      return {
        ...state,
        employeeIdSelected: payload.id,
        employeeFullName: payload.fullName,
        employeeShortName: payload.shortName,
      };

    case SET_APPOINTMENT_EMPLOYEE_DETAILS:
      return {
        ...state,
        appointmentEmployeeDetails: payload,
      };

    case SET_MODAL_ID:
      return {
        ...state,
        displayId: payload,
      };

    case SET_EMPLOYEES_AND_SERVICE:
      return {
        ...state,
        employeeSelected: payload.employeeSelected,
        serviceSelected: payload.serviceSelected,
      };

    case SET_FROM:
      return {
        ...state,
        from: payload,
      };
    case SET_CUSTOMER_DETAILS:
      return {
        ...state,
        customerDetails: payload,
      };
    case SAVE_FORM_DATA:
      return {
        ...state,
        dataOfForm: payload,
      };

    case SET_CONTINUE_BOOKING_DATA:
      return {
        ...state,
        appointmentData: payload
      }

    case RESET_CONTINUE_BOOKING_DATA:
      return {
        ...state,
        appointmentData: ""
      }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/Modal.js